import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './themes';

import Screens from './screens/index.screen';
import { BrowserRouter } from 'react-router-dom';
import MouseHalo from './components/mousehalo.component';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <BrowserRouter>
        <Screens/>
        <MouseHalo/>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
